module.exports = __webpack_public_path__ + "assets/media/vokrug-4.02890b56.svg";